import { Card, CardHeader, Chip, Divider, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { useStyle } from '../style';
import axios from 'axios';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
const SearchItem = ({ setFlag ,  setCode, forwardRef}) => {
    const classes = useStyle()
    const [search, setSearch] = useState("");
    const [itemdata , setItemdata] = useState([])
    const dispatch = useDispatch()
    
    const getItemsData = () => {
        axios.get(`/v1/itemcode/${search}`)
        .then((res) => {
            setItemdata(res.data)
        })
        .catch((err) => {
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        })
    }
    
    useEffect(() => {
        if(search !== ""){
            getItemsData()
        }
    },[search])

    function handleItem(e)  {
        console.log(e.pro_code)
        setCode(e.pro_code)
        setFlag(false)
        setSearch('')
        forwardRef.current.focusCodeInput();
    }
    const handleChipClick = () => {
        setFlag(false);
        setSearch(''); // Clear the search value
      };
    const handleKeyPress = (event) => {
        if (event.ctrlKey && event.key === 'f') {
          setFlag(true);    
          event.preventDefault();
        }
      };
      useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);
        return () => {
          document.removeEventListener('keydown', handleKeyPress);
        };
      }, []);
  return (
    <Grid className='bg-white w-1/3 h-3/4 '>
        <Grid className='flex justify-between items-center m-2'>
        <TextField
                size="small"
                label="Search Code or Product Name"
                value={search}
                autoFocus={true}
                onChange={(e) => setSearch(e.target.value)}
                className={classes.searchTextField}
            />
            <Chip label="Close" variant="outlined" sx={{cursor:"pointer"}} onClick={handleChipClick}/>
        </Grid>
        <Divider sx={{marginBlock:2}}/>
        <Grid className='h-3/4 overflow-auto'>
        {_.map(itemdata , (value , idx) => (
            <Grid key={idx}>
            {search !== "" &&
                <Grid  sx={{margin:1,boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" ,borderRadius:"5px",padding:"10px"}} onClick={()=>handleItem(value)}>
                <Typography sx={{color:"#BA68C8",fontWeight:600}}>Item Details</Typography>
                <Divider sx={{marginBlock:"3px"}}/>
                
                <div className='flex '>
                    <Typography sx={{color:"#000",marginInlineEnd:1}}>Item Name :  </Typography>
                    <Typography sx={{color:"#000"}}> {value.pro_name}</Typography>
                </div>
                <div className='flex '>
                    <Typography sx={{color:"#000",marginInlineEnd:1}}>Item Barcode :  </Typography>
                    <Typography sx={{color:"#000"}}> {value.barcode}</Typography>
                </div>
            </Grid>
            }
        </Grid>
        ))}
        </Grid>
     
        {/* {search!== "" && 
            <Grid sx={{margin:1,boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" ,borderRadius:"5px",padding:"10px"}} onClick={()=>handleItem()}>
                <Typography sx={{color:"#BA68C8",fontWeight:600}}>Item Details</Typography>
                <Divider sx={{marginBlock:"3px"}}/>
                <div className='flex '>
                    <Typography sx={{color:"#000",marginInlineEnd:1}}>Item Name :  </Typography>
                    <Typography sx={{color:"#000"}}> {itemdata.pro_name}</Typography>
                </div>
                <div className='flex '>
                    <Typography sx={{color:"#000",marginInlineEnd:1}}>Item Barcode :  </Typography>
                    <Typography sx={{color:"#000"}}> {itemdata.barcode}</Typography>
                </div>
            </Grid>
        } */}
    </Grid>
  )
}

export default SearchItem